module.exports = __webpack_public_path__ + "static/media/om_eyeshape_round_grey.61a77bd5.png";